import { affiliateTypes } from './affiliate.types';

export const fetchAffiliateData = () => ({
  type: affiliateTypes.FETCH_AFFILIATE_DATA,
});

export const fetchAffiliateDataSuccess = (data) => ({
  type: affiliateTypes.FETCH_AFFILIATE_DATA_SUCCESS,
  payload: data,
});

export const fetchAffiliateDataFailure = (error) => ({
  type: affiliateTypes.FETCH_AFFILIATE_DATA_FAILURE,
  payload: error,
});

export const saveAffiliateData = (data) => ({
  type: affiliateTypes.SAVE_AFFILIATE_DATA,
  payload: data,
});

export const saveAffiliateDataSuccess = (data) => ({
  type: affiliateTypes.SAVE_AFFILIATE_DATA_SUCCESS,
  payload: data,
});

export const saveAffiliateDataFailure = (error) => ({
  type: affiliateTypes.SAVE_AFFILIATE_DATA_FAILURE,
  payload: error,
});
